import styled from 'styled-components'
import Typeahead from '@talus-analytics/library.ui.typeahead'

interface StyledTypeaheadProps {
  landing?: boolean
  nav?: boolean
  itemsSelected?: boolean
}
const StyledTypeaheadControl = styled(Typeahead)<StyledTypeaheadProps>`
  > input {
    height: unset;
    padding: 12px 50px 12px 20px;
    /* ${props => props.landing && 'padding: 12px 20px 12px 50px;'} */
    width: 100%;
    font-size: 0.8rem;
    ${props => props.landing && 'font-size: 1rem;'}
    ${props => props.nav && 'font-size: 0.8rem;'}
    border: 1px solid ${({ theme }) => theme.text};
    ${props =>
      props.landing && `border: 2px solid ${props.theme.callToAction};`}

    border-radius: 5px;
    color: ${({ theme }) => theme.text};
    background-color: ${({ theme }) => theme.backgroundAlternate};
    ::placeholder {
      ${props =>
        props.itemsSelected && !props.landing && `color: ${props.theme.text};`}
    }
  }
  > div {
    > div {
      button {
        color: ${({ theme }) => theme.text} !important;
        &:hover {
          background-color: ${({ theme }) => theme.tags};
        }
      }
      background-color: ${({ theme }) => theme.backgroundAlternate};
      border-bottom: 0px solid white;
      margin-bottom: 0px;
    }
  }
  > div {
    &:first-of-type {
      height: 12px;
      ${props => props.landing && 'height: 18px;'}

      width: 12px;
      ${props => props.landing && 'width: 18px;'}

      top: calc(50% - 6px);
      ${props => props.landing && 'top: calc(50% - 9px);'}

      background-image: ${({ theme }) =>
        `url("data:image/svg+xml,%3Csvg viewBox='0 0 12 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0L6 6L12 0H0Z' fill='${theme.text}'/%3E%3C/svg%3E")`};
      ${props =>
        props.landing &&
        `background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.5 11.755H11.71L11.43 11.485C12.41 10.345 13 8.865 13 7.255C13 3.665 10.09 0.755005 6.5 0.755005C2.91 0.755005 0 3.665 0 7.255C0 10.845 2.91 13.755 6.5 13.755C8.11 13.755 9.59 13.165 10.73 12.185L11 12.465V13.255L16 18.245L17.49 16.755L12.5 11.755ZM6.5 11.755C4.01 11.755 2 9.745 2 7.255C2 4.76501 4.01 2.755 6.5 2.755C8.99 2.755 11 4.76501 11 7.255C11 9.745 8.99 11.755 6.5 11.755Z' fill='${props.theme.text}'/%3E%3C/svg%3E");`}
    }
  }
`

export default StyledTypeaheadControl
